import { combineLatest, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

export function combineMap<TIn, TOut>(
  items: TIn[],
  predicate: (item: TIn) => Observable<TOut | null | undefined>,
): Observable<TOut[]> {
  return items.length === 0
    ? of([])
    : combineLatest(items.map((item) => predicate(item))).pipe(
        map((results) =>
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          results.filter((result) => result != null).map((result) => result!),
        ),
      );
}
